import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button} from '@chekinapp/ui';
import {CustomIcon} from '@guestapp/old-ui-kit';

type TitleProps = {
  $isFaqView?: boolean;
  $hasPayments?: boolean;
  $isKiosko?: boolean;
};

type WrapperProps = {
  $onlyLogo?: boolean;
  $withoutshadow?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  z-index: 5;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 64px;
  padding: 8px 24px;
  background: ${props => props.theme.colors.navigationMenu.backgroundMenu};
  box-shadow: ${({$withoutshadow}) =>
    $withoutshadow
      ? 'none'
      : 'var(--page-header-shadow, 0 2px 10px rgb(147 150 174 / 25%))'};
  /* grid-template-columns: 15px auto 40px; */
  @media (min-width: ${DEVICE.laptop}) {
    // This is a border case, unique for this view based the figma requirements
    margin: 24px 0;
    min-height: auto;
    box-shadow: none;
    background: transparent;
    padding: 0 32px;
    display: grid;
    grid-template-columns: ${({$onlyLogo}) => ($onlyLogo ? '1fr' : '1fr  1fr 1fr')};
  }
`;

export const Title = styled.h1<TitleProps>`
  text-align: ${({$hasPayments}) => ($hasPayments ? 'left' : 'center')};
  font-style: normal;
  font-weight: ${props => props.theme.fonts.fontWeight.mediumL};
  font-size: ${props => props.theme.fonts.sizes.large};
  line-height: 24px;
  width: 100%;
  margin-left: ${({$hasPayments}) => ($hasPayments ? '45px' : '0')};
  color: ${props => props.theme.colors.branding.fontPrimary};
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};

  ${({$isFaqView}) =>
    $isFaqView &&
    css`
      @media (max-width: ${DEVICE.laptop}) {
        margin-right: 24px;
        text-align: right;
      }
    `};
  ${({$isKiosko}) =>
    $isKiosko &&
    css`
      margin-left: 10px;
      text-align: left;
    `};

  @media (min-width: ${DEVICE.laptop}) {
    font-weight: ${props => props.theme.fonts.fontWeight.medium};
    font-size: 24px;
    text-align: center;
    margin: 0;
  }
`;

export const BackButton = styled(Button)`
  display: none;
  position: absolute;
  font-size: ${({theme}) => theme.fonts.sizes.small};
  font-weight: ${({theme}) => theme.fonts.fontWeight.bold};
  width: fit-content;

  color: ${({theme}) =>
    theme.hasTemplate
      ? theme.colors.branding.primary
      : theme.colors.navigationMenu.selectedItemText};

  & .button__left-icon {
    padding-right: 15px;
  }

  @media (min-width: ${DEVICE.laptop}) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }
`;

export const StyledBackIcon = styled(CustomIcon)`
  display: flex;
  justify-content: center;
  align-items: center;

  path {
    fill: ${({theme}) =>
      theme.hasTemplate
        ? theme.colors.branding.primary
        : theme.colors.navigationMenu.selectedItemText};
  }
`;

export const BackIconButton = styled.button<{$position?: string}>`
  all: unset;
  position: ${props => props.$position};
  cursor: pointer;
  transition: opacity 0.1s;

  &:hover {
    opacity: 0.8;
  }

  @media (min-width: ${DEVICE.laptop}) {
    display: none;
  }
`;

export const StyledHeaderLogo = styled.img<{position?: string}>`
  display: block;
  margin: ${props => (props.position === 'center' ? '0 auto' : '0px auto 0 0')};
`;
